import api from "lib/api";

export const getSalaryInformation = async (params = {}) => {
    return await api.post("/v1/employee/getSalaryInformation", params);
};

export const getSalaryDecryptInformation = async (params = {}) => {
    return await api.post("/v1/employee/getSalaryDecryptInformation", params);
};

export const updateSalaryInformation = async (params = {}) => {
    return await api.post("/v1/employee/updateSalaryInformation", params);
};

export const deleteSalaryInformation = async (params = {}) => {
    return await api.post("/v1/employee/deleteSalaryInformation", params);
};

export const getCommonTypeByGroupType = async (params = {}) => {
    return await api.post("/v1/dropdown/getCommonTypeByGroupType", params);
};

export const getCommonTypeCompany = async (params = {}) => {
    return await api.post("/v1/dropdown/getCommonTypeCompany", params);
};

export const getMstAllowances = async (params = {}) => {
    return await api.post("/v1/employee/getMstAllowances", params);
};

export const getAllowances = async (params = {}) => {
    return await api.post("/v1/employee/getAllowances", params);
};

export const updateAllowances = async (params = {}) => {
    return await api.post("/v1/employee/updateAllowances", params);
};

// export const createMovement = async (params = {}) => {
//     return await api.post("/v1/movement/createMovement", params);
// };

export const createMovement = async (params = {}) => {
    return await api.post("/v1/movement/createMovementAllinfo", params);
};

export const getMovementByTypePayment = async (params = {}) => {
    return await api.post("/v1/movement/getMovementByTypePayment", params);
};

export const deleteMovement = async (params = {}) => {
    return await api.post("/v1/movement/deleteMovement", params);
};

export const updateMovement = async (params = {}) => {
    return await api.post("/v1/movement/updateMovement", params);
};

export const getBankOption = async (params = {}) => {
    return await api.post("/v1/dropdown/getBank", params);
};

export const getEmployeeIncomeDeduction = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/getEmployeeIncomeDeduction", params);
};

export const getEmployeeIncomeDeductionForSetup = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/getEmployeeIncomeDeductionForSetup", params);
};


export const getEmployeePaymentMethod = async (params = {}) => {
    return await api.post("/v1/employee/getEmployeePaymentMethod", params);
};

export const getEmployeePayrollPeriod = async (params = {}) => {
    return await api.post("/v1/payrollPeriod/getEmployeePayrollPeriod", params);
};

export const getEmployeePayrollByPeriod = async (params = {}) => {
    return await api.post("/v1/payment/getEmployeePayrollByPeriod", params);
};

export const editEmployeeIncome = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/editEmployeeIncome", params);
};

export const editEmployeeDeduction = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/editEmployeeDeduction", params);
};

export const editEmployeeIncomeDeduction = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/editEmployeeIncomeDeduction", params);
};

export const updatePayrollPaymentByEmployee = async (params = {}) => {
    return await api.post("/v1/payment/updatePayrollPaymentByEmployee", params);
};


export const exportPaySlip = async (params = {}) => {
    return await api.post("/v1/report/exportPaySlip", params, {
        responseType: 'blob'
    });
};
export const previewPaySlipById = async (params = {}) => {
    return await api.post("/v1/payment/previewPaySlipById", params, {
        responseType: 'blob'
    });
};


export const calculateNetIncome = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/calculateNetIncome", params);
};


export const getDataForPaySlip = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/employee", params);
};

export const getStepTaxData = async (params = {}) => {
    return await api.post("/v1/employeeIncomeDeduction/getStepTax", params);
};


export const getAllowancesData = async (params = {}) => {
    return await api.post("v1/employeeIncomeDeduction/getAllowances", params);
};

export const getAuditLogIncomeAndDuection = async (params = {}) => {
    return await api.post("v1/auditlog/getAuditLogIncomeAndDu", params);
}

export const getPayrollPeriodYear = async (params = {}) => {
    return await api.post("/v1/payrollPeriod/year", params);
}

export const getPayrollPeriodByEmployee = async (params = {}) => {
    return await api.post("/v1/payrollPeriod/getPayrollPeriodByEmployee", params);
}

export const getPaySlipReportByPayrollPeriod = async (params = {}) => {
    return await api.post("/v1/payrollPeriod/getPaySlipReportByPayrollPeriod", params, {
        responseType: 'blob'
    });
}

export const getEmployeeOvertimeLists = async (params = {}) => {
    return await api.post("v1/overtimeRequest/overtimeRequestApprovedStatusPaging", params);
}